import { Container, ContentLeft, ContentRight } from "./style";

const Deforestation = () => {
  return (
    <Container>
      <ContentLeft>
        <h3>
          Deforestation is the defining crisis of our time and it is happening
          even more quickly than we feared{" "}
        </h3>
        <button>GET STARTED</button>
      </ContentLeft>
      <ContentRight>
        <p>
          An estimated 10 million hectares of forest are lost each year.
          (Source: World Bank)
        </p>
        <p>
          Between 1990 and 2016, the world lost 1.3 million square kilometers of
          forest, an area larger than South Africa. (Source: Global Forest
          Watch)
        </p>
        <p>
          Around half of the world's original forests have been lost. (Source:
          World Wildlife Fund)
        </p>
        <p>
          Deforestation is responsible for around 15% of global greenhouse gas
          emissions. (Source: United Nations)
        </p>
        <p>
          Forest loss contributes to biodiversity loss, with an estimated 80% of
          the world's land-based species dependent on forests for survival.
          (Source: World Wildlife Fund)
        </p>
      </ContentRight>
      <button>GET STARTED</button>
    </Container>
  );
};
export default Deforestation;
